 <template>

  <div id="main-nav">

    <el-menu
      default-active="dashboard"
      :collapse="nav_collapsed"
      class="el-menu-vertical-demo"
      :router="true">

      <el-menu-item index="/"><vue-material-icon name="insert_chart" :size="icon_size"></vue-material-icon> Dashboard</el-menu-item>

      <el-submenu index="products">
        <template slot="title">
          <span><vue-material-icon name="loyalty" :size="icon_size"></vue-material-icon>Products</span>
        </template>

        <el-menu-item-group title="Products">
          <el-menu-item :disabled="!hasRole('products.can_view')" index="product-list" :route="{ name: 'ProductList'}">View Products</el-menu-item>
          <el-menu-item :disabled="!hasRole('products.can_add')" index="product-add" :route="{ name: 'ProductAdd'}">Add Product</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Types">
          <el-menu-item :disabled="!hasRole('product_types.can_view')" index="product-type-list" :route="{ name: 'ProductTypeList'}">View Product Types</el-menu-item>
          <el-menu-item :disabled="!hasRole('product_types.can_add')" index="product-type-add" :route="{ name: 'ProductTypeAdd'}">Add Product Types</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Category Groups">
          <el-menu-item :disabled="!hasRole('category_groups.can_view')" index="category-group-list" :route="{ name: 'CategoryGroupList'}">View Category Groups</el-menu-item>
          <el-menu-item :disabled="!hasRole('category_groups.can_add')" index="category-group-add" :route="{ name: 'CategoryGroupAdd'}">Add Category Group</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Categories">
          <el-menu-item :disabled="!hasRole('categories.can_view')" index="category-list" :route="{ name: 'ProductCategoryList'}">View Categories</el-menu-item>
          <el-menu-item :disabled="!hasRole('categories.can_add')" index="category-add" :route="{ name: 'CategoryAdd'}">Add Categories</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Print Types">
          <el-menu-item :disabled="!hasRole('print_types.can_view')" index="print-type-list" :route="{ name: 'PrintTypeList'}">View Print Types</el-menu-item>
          <el-menu-item :disabled="!hasRole('print_types.can_add')" index="print-type-add" :route="{ name: 'PrintTypeAdd'}">Add Print Types</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Taxes">
          <el-menu-item :disabled="!hasRole('tax_class.can_view')" index="tax-list" :route="{ name: 'TaxList'}">View Tax Classes</el-menu-item>
          <el-menu-item :disabled="!hasRole('tax_class.can_add')" index="tax-add" :route="{ name: 'TaxAdd'}">Add Tax Class</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Tags">
          <el-menu-item :disabled="!hasRole('tags.can_view')" index="product-tags" :route="{ name: 'ProductTagList'}">View Tags</el-menu-item>
          <el-menu-item :disabled="!hasRole('tags.can_add')" index="tag-add" :route="{ name: 'ProductTagAdd'}">Add Tag</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Shipping Methods">
          <el-menu-item :disabled="!hasRole('shipping_methods.can_view')" index="shipping-methods" :route="{ name: 'ShippingMethodList'}">View Shipping Methods</el-menu-item>
          <el-menu-item :disabled="!hasRole('shipping_methods.can_add')" index="shipping-methods-add" :route="{ name: 'ShippingMethodAdd'}">Add Shipping Methods</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Payment Methods">
          <el-menu-item :disabled="!hasRole('payment_methods.can_view')" index="payment-method-list" :route="{ name: 'PaymentMethodList'}">View Payment Methods</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="orders">
        <template slot="title">
          <vue-material-icon name="receipt" :size="icon_size"></vue-material-icon>
          <span>Orders</span>
        </template>

        <el-menu-item :disabled="!hasRole('orders.can_view')" index="order-list" :route="{ name: 'OrderList'}">View Orders</el-menu-item>
      </el-submenu>

      <el-submenu index="suppliers">
        <template slot="title">
          <vue-material-icon name="person" :size="icon_size"></vue-material-icon>
          <span>Suppliers</span>
        </template>

        <el-menu-item :disabled="!hasRole('suppliers.can_view')" index="supplier-list" :route="{ name: 'SupplierList'}">View Suppliers</el-menu-item>
        <el-menu-item :disabled="!hasRole('suppliers.can_add')" index="supplier-add" :route="{ name: 'SupplierAdd'}">Add Supplier</el-menu-item>
      </el-submenu>

      <el-submenu index="templates">
        <template slot="title">
          <vue-material-icon name="local_printshop" :size="icon_size"></vue-material-icon>
          <span>Templates</span>
        </template>

        <el-menu-item-group title="Templates">
          <el-menu-item :disabled="!hasRole('templates.can_view')" index="template-list" :route="{ name: 'TemplateList'}">View Templates</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Template Categories">
          <el-menu-item :disabled="!hasRole('template_categories.can_view')" index="template-category-list" :route="{ name: 'TemplateCategoryList'}">View Template Categories</el-menu-item>
          <el-menu-item :disabled="!hasRole('template_categories.can_add')" index="template-category-add" :route="{ name: 'TemplateCategoryAdd'}">Add Template Category</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="corporations">
        <template slot="title">
          <vue-material-icon name="fingerprint" :size="icon_size"></vue-material-icon>
          <span>Corporations</span>
        </template>

        <el-menu-item :disabled="!hasRole('corporations.can_view')" index="corporation-list" :route="{ name: 'CorporationList'}">View Corporations</el-menu-item>
        <el-menu-item :disabled="!hasRole('corporations.can_add')" index="corporation-add" :route="{ name: 'CorporationAdd'}">Add Corporation</el-menu-item>
      </el-submenu>

      <el-submenu index="users">
        <template slot="title">
          <vue-material-icon name="invert_colors" :size="icon_size"></vue-material-icon>
          <span>Users</span>
        </template>

        <el-menu-item :disabled="!hasRole('users.can_view')" index="user-list" :route="{ name: 'UserList'}">View Users</el-menu-item>
        <el-menu-item :disabled="!hasRole('users.can_add')" index="user-add" :route="{ name: 'UserAdd'}">Add User</el-menu-item>
      </el-submenu>

      <el-submenu index="reps">
        <template slot="title">
          <vue-material-icon name="account_box" :size="icon_size"></vue-material-icon>
          <span>Reps</span>
        </template>

        <el-menu-item :disabled="!hasRole('reps.can_view_product_catalogue')" index="product-catalogue" :route="{ name: 'ProductCatalogue'}">Product Catalogue</el-menu-item>
        <el-menu-item :disabled="!hasRole('reps.can_view_quote_builder')" index="quote-list" :route="{ name: 'QuoteList'}">Quote Builder</el-menu-item>
      </el-submenu>

      <el-submenu index="user_access">
        <template slot="title">
          <vue-material-icon name="invert_colors" :size="icon_size"></vue-material-icon>
          <span>User Access</span>
        </template>

        <el-menu-item :disabled="!hasRole('user_access.can_view')" index="user-access-list" :route="{ name: 'UserAccessList'}">View User Access</el-menu-item>
        <el-menu-item :disabled="!hasRole('user_access.can_add')" index="user-access-add" :route="{ name: 'UserAccessAdd'}">Add User Access</el-menu-item>
      </el-submenu>

    </el-menu>

  </div>

</template>

<style scoped>

  .menu {
    height:100%;
  }

</style>

<script>

  import Interface from '@/store/Interface.js';
  import Utils from '@/components/utils/Utils.js';
  import store from '@/store/Store.js';

  export default {
    data: function() {
      return {
        permissions: store.permissions,

        nav_collapsed: Interface.state.nav_collapsed,
        icon_size: 20,

        jwt: {
          roles: [],
          access_level: []
        }
      };
    },

      mounted: function() {
        const me = this;
        
        me.jwt = Utils.decodejwt();
      },

      methods: {
        hasRole: function(role_name) {
          const me = this;

          if(me.permissions.user_roles.length > 0) {
            /* returns undefined if doesn't find the role */
            var role = _.find(me.permissions.user_roles, function(o) { 
              return o.name == role_name; 
            });

            /* doesn't enter if when undefined */
            if(role) {
              return true
            }
          }
          
          return false;
        },

        checkRole: function(name) {
            return true;
            const me = this;

            var found_role = me.jwt.roles.some(function (el) {
                return el.name === name
            });

            if(found_role) {
                return true;
            }

            var found_access_role = me.jwt.access_level.some(function (el) {
                return el.name === name
            });

            if(found_access_role) {
                return true;
            }

            return false;
        },         
      }
  }
</script>


// WEBPACK FOOTER //
// src/components/MainNav.vue